import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { TranslocoModule } from "@ngneat/transloco";
import { DirectivesModule } from "../configuration/directives/directives.module";
import { ChangePinCodeModal } from "../modals/change-pin-code/change-pin-code.modal";
import { ChangePinCodeComponent } from "../modals/change-pin-code/change-pin-code.component";
import { LanguagePickerModalModule } from "../modals/language-picker/language-picker.module";
import { AvatarComponent } from "./avatar/avatar.component";
import { CurrentUserComponent } from "./current-user/current-user.component";
import { EnvironmentBarComponent } from "./environment-bar/environment-bar.component";
import { LocationStatusComponent } from "./location-status/location-status.component";
import { MenuBarComponent } from "./menu-bar/menu-bar.component";
import { NumberGridComponent } from "./number-grid/number-grid.component";
import { NumberCounterComponent } from "./number-counter/number-counter.component";
import { NumberSelectorComponent } from "./number-selector/number-selector.component";
import { OperatorLoginModal } from "./operator-login/modals/operator-login.modal";
import { OperatorLoginComponent } from "./operator-login/operator-login.component";
import { PinCodeInputComponent } from "./pin-code-input/pin-code-input.component";
import { SettingsComponent } from "./settings/settings.component";
import { SettingsFabComponent } from "./settings-fab/settings-fab.component";
import { StatisticsNumberComponent } from "./statistics/statistics-number.component";
import { StatisticsTimeComponent } from "./statistics/statistics-time.component";
import { StatisticsComponent } from "./statistics/statistics.component";
import { NoteTemplateComponent } from "../features/notes/components/note-template.component";
import { GroupingComponent } from "./grouping/grouping.component";
import { OfflineMessageComponent } from "./offline-message/offline-message.component";
import { DispatchUndoToastComponent } from "./dispatch-undo-toast/dispatch-undo-toast.component";
import { ScannerModule } from "../modals/scanner/scanner.module";
import { UserPickerModal } from "../features/operators/modals/user-picker.modal";
import { UserPickerComponent } from "../features/operators/modals/user-picker.component";
import { SignatureModule } from "../modals/signature/signature.module";
import { FileUploadsModule } from "../modals/file-uploads/file-uploads.module";
import { ImageViewerModule } from "../modals/image-viewer/image-viewer.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { QueueWidgetSettingsComponent } from "../features/dashboard/widgets/queue-widget-settings.component";
import { UnitListWidgetSettingsComponent } from "../features/dashboard/widgets/unit-list-widget-settings.component";
import { WidgetHideFromDashboardMenuComponent } from "../features/dashboard/widgets/widget-hide-from-dashboard-menu.component";
import { QueueWidgetComponent } from "../features/dashboard/widgets/queue-widget.component";
import { OpenLocationButtonComponent } from "../features/dashboard/components/open-location-button.component";
import { LastUpdatedComponentModule } from "./last-updated/last-updated.module";
import { TextEditorModule } from "../modals/text-editor/text-editor.module";

const components = [
	MenuBarComponent,
	EnvironmentBarComponent,
	CurrentUserComponent,
	LocationStatusComponent,
	AvatarComponent,
	OperatorLoginComponent,
	NumberSelectorComponent,
	NumberCounterComponent,
	NumberGridComponent,
	SettingsComponent,
	SettingsFabComponent,
	PinCodeInputComponent,
	ChangePinCodeComponent,
	StatisticsComponent,
	StatisticsTimeComponent,
	StatisticsNumberComponent,
	NoteTemplateComponent,
	GroupingComponent,
	OfflineMessageComponent,
	DispatchUndoToastComponent,
	UserPickerComponent,
	QueueWidgetComponent,
	QueueWidgetSettingsComponent,
	UnitListWidgetSettingsComponent,
	WidgetHideFromDashboardMenuComponent,
];

@NgModule({
	imports: [
		CommonModule,
		IonicModule,
		RouterModule,
		TranslocoModule,

		LanguagePickerModalModule,
		ScannerModule,
		SignatureModule,
		FileUploadsModule,
		ImageViewerModule,
		TextEditorModule,
		DirectivesModule,
		ReactiveFormsModule,
		LastUpdatedComponentModule,
		FormsModule,
		OpenLocationButtonComponent,
	],
	providers: [OperatorLoginModal, ChangePinCodeModal, UserPickerModal],
	declarations: components,
	exports: components,
})
export class ComponentsModule {}
